function injectScript(url, { async = true, type = 'text/javascript' } = {}) {
    const script = document.createElement('script');
    script.type = type;
    script.async = async;
    script.src = url;
    const domNode = document.getElementsByTagName('script')[0];
    domNode.parentNode.insertBefore(script, domNode);
}

export default {
    injectScript,
};
